import { fetchingProduct } from "../../helpers/fetchingProduct";
import { handlerCardProduct } from "../../helpers/template/functions";
import { templateProduct } from "../../helpers/template/templateProduct";

if (document.querySelector(".header__filters")) {
  const elements = {
    header: document.querySelector(".header"),
    searchLabel: document.querySelector(".header__filters"),
    inputSearch: document.querySelector(".header__filters--input"),
    openFilters: document.querySelector(".header__filters--search"),
    closeFilters: document.querySelector(".header__filters--close"),
    cardFilters: document.querySelector(".search-card"),
    loader: document.querySelector(".search-card .main-fader"),
    renderProducts: document.querySelector(".search-card__products"),
    collectionsHandlers: document.querySelectorAll(".search-handle"),
    chargeMore: document.querySelector(".search-card__rigth--view-all"),
    pageOverlay: document.querySelector(".page-overlay"),
    body: document.querySelector("body"),
  };

  let handleCollection = "";

  const toggleFilters = (isOpen) => {
    elements.searchLabel.classList.toggle("isOpen", isOpen);
    elements.cardFilters.classList.toggle("open", isOpen);
    elements.header.classList.toggle("open", isOpen);
    elements.body.classList.toggle("hidden", isOpen);
  };

  const updateProducts = async (endpoint, isQuery) => {
    elements.renderProducts.style.display = "none";
    elements.loader.style.display = "block";
    try {
      const data = await fetchingProduct(endpoint, "GET");
      const productInConsult = isQuery
        ? data.resources.results.products
        : data.products;
      if (!productInConsult || productInConsult.length === 0) {
        elements.renderProducts.innerHTML =
          "<p class='search-card__not-match'>No se encontraron productos relacionados.</p>";
      } else {
        elements.renderProducts.innerHTML = productInConsult
          .map(templateProduct)
          .join("");

        handlerCardProduct(elements.renderProducts);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      elements.loader.style.display = "none";
      elements.renderProducts.style.display = "grid";
    }
  };

  // Event Listeners
  elements.collectionsHandlers.forEach((collection) => {
    collection.addEventListener("click", () => {
      let inSearch = elements.header.querySelector(
        ".header__filters--menu--span"
      );
      inSearch.textContent = collection.textContent;
      handleCollection = collection.getAttribute("data-handle") || "";
      updateProducts(
        `/collections/${handleCollection}/products.json?limit=4`,
        false
      );
    });
  });

  elements.openFilters.addEventListener("click", () => {
    if (elements.cardFilters.classList.contains("open")) {
      return;
    } else {
      toggleFilters(true);
      updateProducts(`/products.json?limit=4`, false);
    }
  });

  elements.closeFilters.addEventListener("click", () => {
    toggleFilters(false);
  });

  const searchBySKU = async (sku) => {
    elements.renderProducts.style.display = "none";
    elements.loader.style.display = "block";

    try {
      const query = `
        query searchBySKU($query: String!) {
          products(query: $query, first: 1) {
            edges {
              node {
                handle
              }
            }
          }
        }
      `;

      const response = await fetch("/api/2025-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "c327ef1b370479df503389ad2cd4e50a",
        },
        body: JSON.stringify({
          query,
          variables: {
            query: `sku:${sku}`,
          },
        }),
      });

      const data = await response.json();

      if (!data.data.products.edges || data.data.products.edges.length === 0) {
        elements.renderProducts.innerHTML =
          "<p class='search-card__not-match'>No se encontraron productos con el SKU</p>";
        return;
      }

      const productHandle = data.data.products.edges[0].node.handle;
      const productDetails = await fetchingProduct(
        `/products/${productHandle}.json`,
        "GET"
      );

      if (!productDetails.product) {
        elements.renderProducts.innerHTML =
          "<p class='search-card__not-match search-card__error'>No se pudo obtener los detalles del producto</p>";
        return;
      } else {
        let productSingle = productDetails.product;
        console.log(productSingle);

        // elements.renderProducts.innerHTML = `<p class='h1'>Encontrado ${productSingle.title}</p>`;
        elements.renderProducts.innerHTML = templateProduct(productSingle);
      }

      handlerCardProduct(elements.renderProducts);
    } catch (error) {
      console.error("Error searching by SKU:", error);
      elements.renderProducts.innerHTML =
        "<p class='search-card__not-match search-card__error'>Error al buscar productos. Por favor, intente nuevamente.</p>";
    } finally {
      elements.loader.style.display = "none";
      elements.renderProducts.style.display = "grid";
    }
  };
  const handleSearch = () => {
    const query = elements.inputSearch.value.trim();
    if (typeof query === "string" && query.toLowerCase().startsWith("sku:")) {
      const sku = query.slice(4).trim();
      searchBySKU(sku);
      return;
    } else {
      let endpoint;
      let isQuery = false;
      if (handleCollection && query) {
        isQuery = true;
        endpoint = `/search/suggest.json?q=${query}&resources[collection]=${handleCollection}`;
      } else {
        isQuery = query ? true : false;
        endpoint = handleCollection
          ? `/collections/${handleCollection}/products.json?limit=4`
          : `/search/suggest.json?q=${query}&limit=4`;
      }
      elements.chargeMore.style.display = "flex";
      elements.chargeMore.href = `/search?type=product%2Cpage&options%5Bprefix%5D=last&q=${query}`;
      updateProducts(endpoint, isQuery);
    }
  };
  elements.inputSearch.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  });

  elements.inputSearch.addEventListener("input", () => {
    if (elements.inputSearch.value.length > 5) {
      handleSearch();
    }
  });
}
